import React, { memo, useState, useEffect, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { createSelector } from 'reselect';
import { message } from 'antd';

import bytes from 'bytes';
import dayjs from 'dayjs';
import classNames from 'classnames';
import { imgLocalUrl, logNative } from '../../utils/utils';
import { PCStoreJsBridge } from '../../nativeapi';
import { CONTEXT } from '../../config';

import defaultImg from '../../static/default.svg';
import styles from './NotOftenUsedSoft.module.less';

import { logPostInfo, logging } from '../../actions/log';
import { setMenuSpot } from '../../actions/layout';
import { getLocalSoft } from '../../actions/native';
import { addUninstall, cancelUninstall } from '../../actions/uninstall';
import { mySoftKeys } from '../../constants/storageKeys';
import Dialog from '../../components/Dialog/Dialog';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/zh-cn';
import DEFAULT from '../../static/wp_wj.svg';
import ResidualSoft from './ResidualSoft';
import loading from '../../static/loading.gif';
import fingerHeart from '../../static/finger_heart.gif';

dayjs.extend(relativeTime);
dayjs.locale('zh-cn');
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectUninstallSoft = createSelector(
  state => state.native,
  native => native.uninstallSoft,
);

const selectInstalledSoft = createSelector(
  state => state.native,
  native => native.installedSoft,
);

const selectUnistallFinishSoft = createSelector(
  state => state.native,
  native => native.uninstallFinishSoft,
);

export default memo(props => {
  const { soft, logInfo, tempResidualList, pcInstalled } = props;
  const dispatch = useDispatch();
  const [tempResidualInfo, setTempResidualInfo] = useState(null);
  const logInfoData = useSelector(selectLogInfo);
  const installedSoft = useSelector(selectInstalledSoft);
  const uninstallSoftList = useSelector(selectUninstallSoft); // 判断软件能否被卸载

  const [uninstallSoft, setUninstallSoft] = useState(null);
  const [isShowSpot, setIsShowSpot] = useState(false);
  const [visible, setVisible] = useState(false);
  const [uninstallSoftInfo, setUninstallSoftInfo] = useState(null);

  const [constraintTag, setConstraintTag] = useState(false); // 强制卸载弹窗开启标识
  const [startConstrain, setStartConstrain] = useState(false); // 开始强制卸载的标识
  const finishSoft = useSelector(selectUnistallFinishSoft); // 区别当前软件是否是强力卸载好了的软件
  const [uninstallPath, setUninstallPath] = useState(null); //   强力卸载文件路径

  // 后期修补 卸载根目录的bug
  const [isCantUninstall, setIsCantUninstall] = useState(true);

  useEffect(() => {
    const found = uninstallSoftList.find(
      v =>
        (soft.androidType !== '1' && v.softGUID === soft.softGUID) ||
        (soft.androidType === '1' && v.packageName === soft.packageName),
    );
    setUninstallSoft(found || null);
  }, [uninstallSoftList]);

  useEffect(() => {
    const data =
      tempResidualList &&
      tempResidualList.find(item => {
        return item.softGUID === soft.softGUID;
        // && item.isx64 === soft.isx64;
      });
    setTempResidualInfo(data);
  }, [tempResidualList, soft]);

  // 展示设置小红点
  useEffect(() => {
    const spotSoftStr = localStorage.getItem(mySoftKeys.RED_SPOT_SOFT) || '';
    if (soft && soft.packageName) {
      setIsShowSpot(spotSoftStr.indexOf(soft.packageName) > -1);
    }
  }, [installedSoft, soft]);

  const handleOpen = useCallback(
    softInfo => {
      const logParam2 = {
        source: 'Mysofts',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
        softid: softInfo.softID,
        softName: softInfo.softName,
        softType: 'o',
        url: softInfo.downLoadUrl || softInfo.downloadUrl,
        type: 'o',
      };
      // 按钮点击打桩
      logParam2.type = 'o';
      if (softInfo.androidType === '1') {
        logParam2.softType = '1';
        logParam2.softid = softInfo.packageName;
        logParam2.versionCode = softInfo.versionCode;
        logParam2.softName = softInfo.softName;
        // 首先判断模拟器是否已经安装。
        PCStoreJsBridge.getIsSIMInstalled().then(SIMInstalled => {
          if (SIMInstalled) {
            PCStoreJsBridge.openAndroidSoft({ ...softInfo, logInfo: logParam2 }).then(isOpen => {
              if (isOpen !== true) {
                message.config({ top: 318, duration: 2.8 });
                message.info('软件运行失败！');
                dispatch(getLocalSoft());
              }
            });
          } else {
            // 当不存在模拟器重新获取一次本地列表改变按钮的状态。
            dispatch(getLocalSoft());
          }
        });

        // 展示取消小红点
        // 是否为第一次打开，取消小红点
        logParam2.type = '0';
        const spotSoftStr = localStorage.getItem(mySoftKeys.RED_SPOT_SOFT);
        const spotSoft = spotSoftStr && spotSoftStr.split(',');
        if (spotSoft && spotSoft.indexOf(softInfo.packageName) > -1) {
          spotSoft.splice(spotSoft.indexOf(softInfo.packageName), 1);
          localStorage.setItem(mySoftKeys.RED_SPOT_SOFT, spotSoft.join(','));
          setIsShowSpot(false);
          logParam2.type = '1';
        }

        // 更新菜单上的小红点
        const spotSoftStrNew = localStorage.getItem(mySoftKeys.RED_SPOT_SOFT);
        const installedSpotSoft = installedSoft.find(
          softItem =>
            softItem.androidType === '1' &&
            spotSoftStrNew &&
            spotSoftStrNew.indexOf(softItem.packageName) > -1,
        );
        dispatch(setMenuSpot(installedSpotSoft && installedSpotSoft.packageName));
      } else {
        logParam2.softType = '0';
        logParam2.softid = softInfo.SoftID;
        logParam2.softName = softInfo.displayName;
        PCStoreJsBridge.openSoft(softInfo).then(isOpen => {
          if (isOpen !== true) {
            message.config({ top: 318, duration: 2.8 });
            message.info('软件运行失败！');
            dispatch(getLocalSoft());
          }
        });
      }
      dispatch(
        logging({
          category: 'C',
          action: 'Mysofts_Open',
          label: '',
          param2: logParam2,
          param3: softInfo.bizInfo || '{}',
        }),
      );
    },
    [dispatch, logInfoData],
  );

  const handleUninstall = useCallback(
    (softInfo, uninstallType) => {
      const logParam2 = {
        source: 'Mysofts',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
        softid: softInfo.softID || softInfo.SoftID || '',
        softname: softInfo.softGUID,
        softType: softInfo.androidType === '1' ? '1' : '0',
      };
      if (softInfo.androidType === '1') {
        logParam2.softid = softInfo.packageName;
      }
      // 卸载页面-继续卸载
      if (uninstallType === 'modal') {
        dispatch(
          logging({
            category: 'C',
            action: 'Uninstall_Protect_Continue',
            label: '',
            param2: logParam2,
          }),
        );
      }
      // 关闭弹窗
      setVisible(false);
      // 添加卸载任务，开始卸载软件
      logNative(
        `开始调用卸载软件，添加卸载任务NotOften, ${JSON.stringify(logParam2)}`,
        softInfo,
        true,
        true,
      );
      dispatch(addUninstall(softInfo));
      if (softInfo.androidType === '1') {
        PCStoreJsBridge.uninstallAndroidSoft(softInfo).then(succ => {
          if (succ !== 'true') {
            dispatch(cancelUninstall(softInfo));
          }
        });
      } else {
        PCStoreJsBridge.uninstallSoft({ ...softInfo, mode: 1 });
      }
    },
    [dispatch, logInfoData],
  );

  const handleUnInstallOper = useCallback(softInfo => {
    const logParam2 = {
      source: 'Mysofts',
      source_p: logInfoData.source_p,
      source_pp: logInfoData.source_pp,
      softid: softInfo.softID || softInfo.SoftID || '',
      softname: softInfo.softGUID,
      softType: softInfo.androidType === '1' ? '1' : '0',
    };
    if (softInfo.androidType === '1') {
      logParam2.softid = softInfo.packageName;
    }
    // 卸载页面-点击创建快捷方式-打桩
    dispatch(
      logging({
        category: 'C',
        action: 'T_Cleaner',
        label: '',
        param2: logParam2,
      }),
    );
    if (!softInfo.title) {
      handleUninstall(softInfo);
      return;
    }
    setUninstallSoftInfo(softInfo);
    setVisible(true);
    // 打开卸载保护弹窗打桩
    dispatch(
      logging({
        category: 'P',
        action: 'Uninstall_Protect',
        label: '',
        param2: logParam2,
      }),
    );
  });

  const handleCancelModal = useCallback(
    uninstallType => {
      setVisible(false);
      if (uninstallType === 'modal') {
        // 通过弹窗里面暂不卸载 关闭卸载保护弹窗
        dispatch(
          logging({
            category: 'C',
            action: 'Uninstall_Protect_Cancel',
            label: '',
            param2: {
              source: 'Mysofts',
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              softid: soft.softID || soft.SoftID || '',
              softname: soft.softGUID,
              softType: soft.androidType === '1' ? '1' : '0',
            },
          }),
        );
        return;
      }
      // 直接关闭卸载保护弹窗
      dispatch(
        logging({
          category: 'C',
          action: 'Uninstall_Protect_Close',
          label: '',
          param2: {
            source: 'Mysofts',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softid: soft.softID || soft.SoftID || '',
            softname: soft.softGUID,
            softType: soft.androidType === '1' ? '1' : '0',
          },
        }),
      );
    },
    [logInfoData],
  );

  const handleSoftCard = useCallback(() => {
    const source = logInfo ? logInfo.source : 'Mysofts';
    dispatch(
      logPostInfo({
        source_p: source,
        source_pp: logInfoData.source_p,
      }),
    );
  }, [dispatch]);

  /**
   * 添加临时逻辑判断, 后期修补 卸载根目录的bug
   */
  const judgeChildPath = pathStr => {
    if (pathStr) {
      let pathList = pathStr.split(/\\/);
      let startIndex = pathList.findIndex(item => item === '..');
      while (startIndex > -1) {
        pathList.splice(startIndex - 1, 2);
        startIndex = pathList.findIndex(item => item === '..');
      }
      pathList = pathList.filter(item => item && !/\.exe$/.test(item));
      return pathList.length > 1;
    }
    return false;
  };

  useEffect(() => {
    if (!soft.installString && !soft.MainExePath) {
      return;
    }
    if (!judgeChildPath(soft.installString, soft) && !judgeChildPath(soft.MainExePath, soft)) {
      setIsCantUninstall(false);
      logNative(`卸载目录不常规，屏蔽这个软件 ${soft}`, {}, true, true);
    }
  }, [soft]);

  if (
    tempResidualInfo &&
    !judgeChildPath(soft.installString) &&
    !judgeChildPath(soft.MainExePath)
  ) {
    return null;
  }

  // 点击卸载后先进行判断是否是需要强制卸载
  const constraintJudge = softInfo => {
    if (softInfo.androidType !== '1') {
      PCStoreJsBridge.judgeUninstallSoft({
        isuwp: softInfo.isuwp,
        isx64: softInfo.isx64,
        softGUID: softInfo.softGUID,
      }).then(res => {
        if (res.mode === 1) {
          handleUnInstallOper(softInfo);
        } else if (res.mode === 2) {
          setUninstallPath(res.installpath);
          setConstraintTag(true);
        }
      });
    } else {
      handleUnInstallOper(softInfo);
    }
  };

  // 开始强力卸载
  const startConstrainUninstall = soft => {
    setStartConstrain(true);
    setConstraintTag(false);
    PCStoreJsBridge.uninstallSoft({
      isuwp: soft.isuwp,
      softGUID: soft.softGUID,
      isx64: soft.isx64,
      mode: 2,
    });
  };

  // 强制卸载打开文件夹对应路径
  const openSoftFolder = () => {
    PCStoreJsBridge.openFolder(uninstallPath);
  };

  // 关闭强力卸载的弹出框
  const handleCloseConstrain = () => {
    setConstraintTag(false);
  };

  return (
    <>
      {!tempResidualInfo &&
        pcInstalled &&
        pcInstalled.find(item => item.SoftID === soft.SoftID || item.softID === soft.SoftID) && (
          <>
            {soft.androidType === '1' ? (
              <div
                data-softtag={`${soft.softGUID}-${soft.isx64}`}
                className={!uninstallSoft ? styles.line_soft : styles.line_soft_disable}
              >
                <div className={styles.soft_logo}>
                  <img src={soft.logoFile} alt="" />
                  <div className={`${styles.icon}  ${styles.alogo}`} />
                </div>
                <div className={styles.soft_info}>
                  {soft.packageName ? (
                    <Link
                      className={styles.soft_info_name}
                      to={{
                        pathname: `${CONTEXT}/adetail/${soft.packageName}/${soft.versionCode ||
                          0}/${soft.bizInfo || '{}'}`,
                      }}
                      onClick={() => {
                        handleSoftCard(soft);
                      }}
                    >
                      {soft.softName}
                    </Link>
                  ) : (
                    <div className={styles.soft_info_name}>{soft.softName}</div>
                  )}
                  <div className={styles.soft_info_desc}>{soft.publisher}</div>
                </div>
                <div className={styles.soft_time}>
                  上次使用时间：
                  {soft.usedTime || soft.installdate
                    ? dayjs(soft.usedTime || soft.installdate).fromNow()
                    : '3个月前'}
                </div>
                <div className={styles.soft_size}>
                  {bytes(Number(soft.estimateSize), { unitSeparator: ' ' })}
                </div>
                <div className={styles.soft_operation}>
                  <div
                    className={styles.uninstall_btn}
                    onClick={() => {
                      if (!uninstallSoft) {
                        handleUnInstallOper(soft);
                      }
                    }}
                  >
                    {!uninstallSoft ? '卸载' : '卸载中'}
                  </div>
                  <div
                    className={styles.open_btn}
                    onClick={() => {
                      if (!uninstallSoft) {
                        handleOpen(soft);
                      }
                    }}
                  >
                    <span>打开</span>
                    {isShowSpot && <span className={styles.open_btn_spot} />}
                  </div>
                </div>
              </div>
            ) : (
              <div
                data-softtag={`${soft.softGUID}-${soft.isx64}`}
                className={!uninstallSoft ? styles.line_soft : styles.line_soft_disable}
              >
                <div className={styles.soft_logo}>
                  <img
                    src={
                      soft.logoFile ||
                      (soft.displayIcon ? imgLocalUrl(soft.displayIcon) : defaultImg)
                    }
                    alt=""
                  />
                </div>
                <div className={styles.soft_info}>
                  {soft.SoftID ? (
                    <Link
                      className={styles.soft_info_name}
                      to={`${CONTEXT}/detail/soft/${soft.SoftID}/${soft.bizInfo || '{}'}`}
                      onClick={() => {
                        handleSoftCard(soft);
                      }}
                    >
                      <div className={styles.soft_info_name} title={soft.displayName}>
                        {soft.displayName}
                      </div>
                    </Link>
                  ) : (
                    // eslint-disable-next-line no-underscore-dangle
                    <div className={styles.soft_info_name_} title={soft.displayName}>
                      {soft.displayName}
                    </div>
                  )}
                  <div className={styles.soft_info_desc} title={soft.publisher}>
                    {soft.publisher}
                  </div>
                </div>
                {startConstrain && (
                  <>
                    {soft.softGUID === finishSoft.softGUID ? (
                      <div className={styles.constrain_finish}>
                        <img src={fingerHeart} />
                        卸载成功
                      </div>
                    ) : (
                      <div className={styles.constrain_uninstall}>
                        <img src={loading} />
                        正在进行应用卸载，请耐心等待...
                      </div>
                    )}
                  </>
                )}
                {!startConstrain && (
                  <>
                    <div className={styles.soft_time}>
                      上次使用时间：
                      {soft.usedTime || soft.installdate
                        ? dayjs(soft.usedTime || soft.installdate).fromNow()
                        : '3个月前'}
                    </div>
                    <div className={styles.soft_size}>
                      {soft.estimateSize !== '0'
                        ? bytes(Number(soft.estimateSize), { unitSeparator: ' ' })
                        : '未知'}
                    </div>
                    <div className={styles.soft_operation}>
                      {isCantUninstall ? (
                        <div
                          className={styles.uninstall_btn}
                          onClick={() => {
                            if (!uninstallSoft) {
                              // handleUnInstallOper(soft);
                              constraintJudge(soft);
                            }
                          }}
                        >
                          {!uninstallSoft ? '卸载' : '卸载中'}
                        </div>
                      ) : (
                        <div className={styles.uninstall_btn_disable}>卸载</div>
                      )}
                      {soft.MainExePath ? (
                        <div
                          className={styles.open_btn}
                          onClick={() => {
                            if (!uninstallSoft) {
                              handleOpen(soft);
                            }
                          }}
                        >
                          打开
                        </div>
                      ) : (
                        <div className={styles.open_btn_disable}>打开</div>
                      )}
                    </div>
                  </>
                )}
                {/* <div className={styles.soft_time}>
                  上次使用时间：
                  {soft.usedTime || soft.installdate
                    ? dayjs(soft.usedTime || soft.installdate).fromNow()
                    : '3个月前'}
                </div>
                <div className={styles.soft_size}>
                  {soft.estimateSize !== '0'
                    ? bytes(Number(soft.estimateSize), { unitSeparator: ' ' })
                    : '未知'}
                </div>
                <div className={styles.soft_operation}>
                  {isCantUninstall ? (
                    <div
                      className={styles.uninstall_btn}
                      onClick={() => {
                        if (!uninstallSoft) {
                          handleUnInstallOper(soft);
                        }
                      }}
                    >
                      {!uninstallSoft ? '卸载' : '卸载中'}
                    </div>
                  ) : (
                    <div className={styles.uninstall_btn_disable}>卸载</div>
                  )}
                  {soft.MainExePath ? (
                    <div
                      className={styles.open_btn}
                      onClick={() => {
                        if (!uninstallSoft) {
                          handleOpen(soft);
                        }
                      }}
                    >
                      打开
                    </div>
                  ) : (
                    <div className={styles.open_btn_disable}>打开</div>
                  )}
                </div> */}
              </div>
            )}
          </>
        )}

      {tempResidualInfo && (
        <ResidualSoft
          residualInfo={{
            ...tempResidualInfo,
            logoFile:
              (soft[soft.SoftID || soft.softid] && soft[soft.SoftID || soft.softid].logoFile) ||
              tempResidualInfo.logoFile,
          }}
          soft={{
            ...tempResidualInfo,
            ...soft,
            logoFile:
              (soft[soft.SoftID || soft.softid] && soft[soft.SoftID || soft.softid].logoFile) ||
              tempResidualInfo.logoFile,
          }}
        />
      )}
      {visible && (
        <Dialog
          maskStyle={styles.mask}
          containerStyle={styles.containerStyle}
          title="温馨提示"
          handleClose={handleCancelModal}
        >
          <div className={styles.modal_content}>{uninstallSoftInfo && uninstallSoftInfo.title}</div>
          <div className={styles.modal_button}>
            <div
              className={classNames(styles.button, styles.install)}
              onClick={() => {
                handleUninstall(uninstallSoftInfo, 'modal');
              }}
            >
              继续卸载
            </div>
            <div
              className={classNames(styles.button, styles.uninstall)}
              onClick={() => {
                handleCancelModal('modal');
              }}
            >
              暂不卸载
            </div>
          </div>
        </Dialog>
      )}
      {constraintTag && (
        <Dialog
          maskStyle={styles.mask}
          containerStyle={styles.force_delete}
          handleClose={handleCloseConstrain}
          title=""
        >
          <div className={styles.title}>该应用无法正常卸载，建议强制删除</div>
          {uninstallPath ? (
            <div className={styles.message}>
              强制删除会将该应用目录下所有文件删除，您可以 查看
              <span className={styles.open} onClick={openSoftFolder}>
                <img src={DEFAULT} /> 安装目录
              </span>
              是否存在重要文件
            </div>
          ) : (
            <div className={styles.message}>
              强制删除时会删除软件相关文件，请确认是否进行删除操作
            </div>
          )}
          <div className={styles.btn_operation}>
            <div className={styles.btn} onClick={handleCloseConstrain}>
              取消
            </div>
            <div className={styles.btn_create} onClick={() => startConstrainUninstall(soft)}>
              强制删除
            </div>
          </div>
        </Dialog>
      )}
    </>
  );
});
